import {
  ITransaction,
  TransactionAmount,
  getTransactionAvatar,
} from '@/entities/transaction';

import { cn } from '@/shared/lib';
import { capitalize } from '@/shared/lib/utils/text';
import { AvatarWithIndicator, Typography } from '@/shared/ui';

import { FINAL_STATUSES } from '../config';
import { TransactionsDetailsModal } from './details/details-modal';

interface TransactionInProcessProps {
  transaction: ITransaction;
  className?: string;
}
export const TransactionInProcess = ({
  transaction,
  className,
}: TransactionInProcessProps) => {
  const { avatar, defaultAvatar } = getTransactionAvatar(
    transaction,
    'bg-surface-03',
  );
  return (
    <TransactionsDetailsModal transaction={transaction} key={transaction.id}>
      {(setIsDetailsOpen) => (
        <div
          className={cn(
            'flex cursor-pointer items-center pb-2 pt-5',
            className,
          )}
          tabIndex={0}
          onClick={setIsDetailsOpen}
        >
          <AvatarWithIndicator
            className="pr-4"
            showIndicator={!FINAL_STATUSES.includes(transaction.status)}
            avatar={avatar}
            defaultAvatar={defaultAvatar}
          />
          <div className="flex flex-col gap-1">
            <Typography variant="16-r">{transaction.name}</Typography>
            <Typography
              variant="14-r"
              color="text-base-100"
              className="capitalize"
            >
              {capitalize(transaction.status)}
            </Typography>
          </div>
          <TransactionAmount
            transaction={transaction}
            className="ml-auto self-start pl-2"
          />
        </div>
      )}
    </TransactionsDetailsModal>
  );
};
